export default function addBoNumSlots(e, setMuBookData, muBookData) {
    const value = e.target.value;
    const slots = parseInt(value, 10);
    if (isNaN(slots) || slots === -1) {
        setMuBookData((prev) => ({
            ...prev,
            totalSeats: -1,
            userDetails: []
        }));
        return;
    }
    let tempUser = [...muBookData.userDetails];
    while (tempUser.length < slots) {
        tempUser.push({});
    }
    while (tempUser.length > slots) {
        tempUser.pop();
    }
    setMuBookData((prevState) => {
        return {
            ...prevState,
            totalSeats: slots,
            userDetails: tempUser
        };
    });
}

export const handleTotalRooms = (e, setMuBookData) => {
    const value = e.target.value;
    const rooms = parseInt(value, 10);
    if (isNaN(rooms) || rooms === -1) {
        setMuBookData((prev) => ({
            ...prev,
            totalRooms: -1
        }));
        return;
    }
    setMuBookData((prev) => ({
        ...prev,
        totalRooms: rooms
    }));
};
